import { Component, Input, HostBinding } from '@angular/core';

@Component({
  selector: 'jhi-plan-site-item',
  templateUrl: './plan-site-item.component.html',
  styleUrls: ['./plan-site-item.component.scss']
})
export class PlanSiteItemComponent {

  @Input()
  routePath: string;

  @Input()
  routeTitle: string;

  @HostBinding('class.sub-item')
  @Input()
  isSubItem: boolean;

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/layouts/footer/plan-site/plan-site-item/plan-site-item.component.ts